// extracted by mini-css-extract-plugin
module.exports = {"freeform":"ScheduleLegend_freeform__UQiIO","specialty":"ScheduleLegend_specialty__eVsNr","cp":"ScheduleLegend_cp__27h_u","container":"ScheduleLegend_container__2A0S4"};